import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { StringValue } from "./StringValue";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Boss Kill">
      <CardContent>
        <AccountDetailsSection task={task} />
        <StringValue
          label={"BossKill Hero"}
          value={task.taskstatusdetail.atkheroname}
        />
        <StringValue
          label={"Summoning Hero"}
          value={task.taskstatusdetail.defheroname}
        />
        <StatusSection task={task} />
        <StringValue
          label={
            <>
              Total bosses hit
              <br />
              (hit does not guarantee that boss was defeated,
              <br />
              that depends on troops and heroes selected):
            </>
          }
          value={task.taskstatusdetail.totalbossesdone}
        />
        <StringValue
          label={"Time remaining for next Hit:"}
          value={task.taskstatusdetail.timeremainingfornexthit}
        />
        <StringValue
          label={"Boss selected for killing/summoning:"}
          value={task.taskstatusdetail.selectedAlliBoss.bossname}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
